/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_UnconfirmedInputs */



/**
* | output |
* | --- |
* | "Your provider has not confirmed this email address. Use the email link instead." |
*
* @param {Portal_X13_Error_UnconfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_unconfirmed = /** @type {((inputs?: Portal_X13_Error_UnconfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_UnconfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your provider has not confirmed this email address. Use the email link instead.")
});